document.addEventListener("DOMContentLoaded", function () {
    const sectionId = document.getElementById("main-product-section-id").value;

    const escOosFormRelocate = () => {
        const oosForm = document.getElementById('esc-oos-form');
        if (!oosForm) return;

        const wrapper = oosForm.parentElement;
        const isDesktop = window.innerWidth > 750;

        //목적지
        const desktopParent = document.querySelector('.pdp-button-group');
        const mobileParent = document.querySelector('.mobile-pdp-button-group product-form');
        const destination = isDesktop ? desktopParent : mobileParent;

        if (destination) {
            //옮길 자리에 있다면 그대로 종료
            if (isDesktop && destination.nextElementSibling === wrapper) return;
            if (!isDesktop && destination.contains(wrapper)) return;

            if (isDesktop) {
                destination.after(wrapper);
            } else {
                destination.appendChild(wrapper);
            }
        }
    };

    //재입고 알림 dom 최초 1회만 감지하고 종료허ㅏㅁ
    const initObserver = new MutationObserver((_, observer) => {
        if (document.getElementById('esc-oos-form')) {
            observer.disconnect();
            escOosFormRelocate();
        }
    });
    initObserver.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('resize', debounce(()=>{
        escOosFormRelocate();
    }, 250));

    subscribe(PUB_SUB_EVENTS.variantSoldout, (event) => {

        const variantId = event.data.variant.id.toString();
        const eventSectionId = event.data.sectionId;
        const isSoldOut = event.data.isSoldOut;

        if(sectionId === String(eventSectionId)) {
            const ecsOosFormDom = document.getElementById('esc-oos-form');
            const deliveryDateDoms = document.querySelectorAll(".delivery-date")

            if(deliveryDateDoms) {
                if(isSoldOut) {
                    deliveryDateDoms.forEach(dom => dom.classList.add('hidden'));
                } else {
                    deliveryDateDoms.forEach(dom => dom.classList.remove('hidden'));
                }
            }

            if(ecsOosFormDom) {
                if(isSoldOut) {
                    ecsOosFormDom.classList.remove('hidden');
                } else {
                    ecsOosFormDom.classList.add('hidden');
                }
            }
        }
    });
})

{
    document.addEventListener('DOMContentLoaded', () => {
        setupFormVariationListener('form input[type="hidden"][name="id"]', '.product');

        const submitButtons = document.querySelectorAll('.product-form__submit.button-disable');
        submitButtons.forEach(button => button.classList.remove('button-disable'));
    });

    function setupFormVariationListener(inputSelector, targetSelector = null) {
        const inputElement = document.querySelector(inputSelector);

        if (!inputElement) {
            console.warn('Variation Input not found:', inputSelector);
            return;
        }

        // 타겟 요소 설정 (없으면 인풋이 속한 폼 자체를 타겟으로)
        const targetElement = targetSelector ? document.querySelector(targetSelector) : inputElement.closest('form');

        // [중요] Shopify 전역 객체 체크 (에러 방지)
        if (typeof meta === 'undefined' || !meta.product || !meta.product.variants) {
            console.warn('Meta data not found. Cannot update prices.');
            return;
        }

        const updateAttributes = (newId) => {
            const variant = meta.product.variants.find(v => v.id == newId);

            if (variant) {
                if (variant.sku && targetElement) {
                    targetElement.setAttribute('data-cnstrc-item-variation-id', variant.sku);
                }
                if (variant.price && targetElement) {
                    targetElement.setAttribute('data-cnstrc-item-price', variant.price / 100);
                }
            }
        };


        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                    updateAttributes(inputElement.value);
                }
            });
        });
        observer.observe(inputElement, { attributes: true, attributeFilter: ['value'] });

        inputElement.addEventListener('change', (event) => {
            updateAttributes(event.target.value);
        });
    }
}

document.addEventListener('DOMContentLoaded', function() {


    //SNS 토글 (.btn-open)
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('.btn-open');
        if (!btn) return;

        e.preventDefault();

        // 같은 부모 안에서 형제 .social 찾기
        const social = btn.parentElement?.querySelector('.social');
        if (!social) return;

        social.classList.toggle('open');
    });


    // 오퍼 리스트 높이 체크 및 클릭 이벤트 (.offer-list)
    const offerLists = document.querySelectorAll('.offer-block .offer-list');
    offerLists.forEach(list => {
        const offDescEL = list.querySelector('.offer-desc');
        if (offDescEL) {
            const offOffset = offDescEL.offsetHeight;
            const offScroll = offDescEL.scrollHeight;

            // 내용이 넘칠 경우에만 클릭 이벤트 및 커서 활성화
            if (offScroll > offOffset) {
                offDescEL.style.cursor = 'alias';
                offDescEL.addEventListener('click', () => {
                    offDescEL.classList.toggle('desc-full');
                });
            }
        }
    });

    // --- [이전에 변환했던 함수들 실행] ---

    initScrollState();    // 초기 스크롤 위치 설정
    sizeguideFun();       // 사이즈 가이드 열기/닫기 (이벤트 위임 방식)

    // 다른 함수들이 정의되어 있다면 실행
    if (typeof sizeGuideToggle === 'function') sizeGuideToggle();
    if (typeof returnbacktoggle === 'function') returnbacktoggle();
});

function initScrollState() {
    const targetEl = document.getElementById('find-in-store');
    if (window.location.hash === "#find-in-store" && targetEl) {
        const targetPosition = targetEl.getBoundingClientRect().top + window.scrollY - 400;
        window.scrollTo({ top: targetPosition });
    } else {
        const shipAddress = document.getElementById('ship-address');
        if (shipAddress) shipAddress.blur();
        window.scrollTo(0, 0);
    }
}

function sizeguideFun() {
    const body = document.body;
    const sizeGuide = document.getElementById('sizeguide');

    body.addEventListener('click', (e) => {
        // 사이즈 가이드 열기
        if (e.target.closest('.sizeguide-btn')) {
            if (sizeGuide) sizeGuide.style.display = 'block';
            body.classList.add('dialog-open');
        }
        // 사이즈 가이드 닫기
        if (e.target.closest('.dialog-close')) {
            if (sizeGuide) sizeGuide.style.display = 'none';
            body.classList.remove('dialog-open');
        }
        // 스토어 찾기 스크롤 이동
        const storeLink = e.target.closest('.store-oos a');
        if (storeLink) {
            const targetEl = document.getElementById('find-in-store');
            if (targetEl) {
                const targetPosition = targetEl.getBoundingClientRect().top + window.scrollY - 400;
                window.scrollTo({ top: targetPosition, behavior: 'smooth' });
            }
        }
    });
}